import type { Breakpoint } from './Table'
import { Tag } from '@sunwebgroup/uds-ui/tag'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { type getFilteredRooms, getStagedRoomOccupancyText, isRoomChanged } from '../selectors'
import { RoomParticipantsSubtitle } from './RoomParticipantsSubtitle'
import styles from './RoomTableRow.module.css'
import {
  ChevronCell,
  Subtitle,
  TableCell,
  TableCellWithSubtitle,
  TableRow,
} from './Table'

const breakpointHideCol: Breakpoint = 'primitives_breakpoint_m_max'

export interface RoomTableRowProps {
  room: ReturnType<typeof getFilteredRooms>[number]
  onClick: () => void
}

export function RoomTableRow({ room, onClick }: RoomTableRowProps) {
  const intl = useIntl()
  const isChanged = useGroupResponsibleStore(state => isRoomChanged(state, room.id))
  const occupancyText = useGroupResponsibleStore(state => getStagedRoomOccupancyText(state, room.id))

  return (
    <TableRow onClick={onClick}>
      <TableCellWithSubtitle>
        {isChanged && (
          <div className={styles.tagWrapper}>
            <Tag variant="informative-tinted" size="S">
              {intl.formatMessage({ id: 'groups_responsible_room_changed_label' })}
            </Tag>
          </div>
        )}
        <div className={styles.roomNameWrapper}>
          <span>{room.name}</span>
        </div>
        <Subtitle>
          <RoomParticipantsSubtitle roomId={room.id} />
        </Subtitle>
      </TableCellWithSubtitle>
      <TableCell $hideOn={breakpointHideCol}>{room.type ? room.type : '-'}</TableCell>
      <TableCell $alignRight>
        {room.needsAction
          ? (
              <Tag variant="warning-tinted">
                {intl.formatMessage({ id: 'groups_responsible_action_required_label' })}
              </Tag>
            )
          : occupancyText}
      </TableCell>
      <ChevronCell $hideOn={breakpointHideCol} />
    </TableRow>
  )
}
